import React, { useState } from 'react'
import { css } from 'glamor'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { colours } from '../../../constants/colourConstants'

import Image from './Image'

const ImageWrapper = ({
    image,
    alt = "Plexi's Veterinary Software",
    theme,
    trianglePosition = "bottom-left",
    coloursObj = false,
    axisMultipliers = { x: 0.3, y: 0.4 },
    imageStyles,
}) => {
    const [currentY, setCurrentY] = useState(0);
    const triangleColour = coloursObj ? coloursObj.triangleColour : colours.primary[theme][200];
    const backgroundColor = coloursObj ? coloursObj.backgroundColor : colours.primary[theme][50];

    useScrollPosition((props) => {
        setCurrentY(props.currPos.y)
    }, [], 300);

    const defaultFlexStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        flexDirection: "row",
        flexWrap: "wrap",
    }

    const getTriangleStyles = () => {
        if (trianglePosition === "top-left") {
            return {
                top: 0,
                left: 0,
                borderTop: `${Math.abs(currentY) * axisMultipliers.y}px solid ${triangleColour}`,
                borderRight: `${Math.abs(currentY) * axisMultipliers.x}px solid transparent`
            }
        } else if (trianglePosition === "top-right") {
            return {
                top: 0,
                right: 0,
                borderTop: `${Math.abs(currentY) * axisMultipliers.y}px solid ${triangleColour}`,
                borderLeft: `${Math.abs(currentY) * axisMultipliers.x}px solid transparent`
            }
        } else if (trianglePosition === "bottom-left") {
            return {
                bottom: 0,
                left: 0,
                borderBottom: `${Math.abs(currentY) * axisMultipliers.y}px solid ${triangleColour}`,
                borderRight: `${Math.abs(currentY) * axisMultipliers.x}px solid transparent`
            }
        } else if (trianglePosition === "bottom-right") {
            return {
                bottom: 0,
                right: 0,
                borderBottom: `${Math.abs(currentY) * axisMultipliers.y}px solid ${triangleColour}`,
                borderLeft: `${Math.abs(currentY) * axisMultipliers.x}px solid transparent`
            }
        }
    }

    return (
        <div
            {...css({
                position: "relative",
                height: "100%",
                overflow: "hidden",
            })}
        >
            <div
                {...css({
                    position: "relative",
                    display: "block",
                    width: "100%",
                    height: "100%",
                    padding: 20,
                    ...!imageStyles && defaultFlexStyles
                })}
            >
                <Image
                    retinaReady
                    alt={alt}
                    image={image}
                    {...css({
                        position: "relative",
                        zIndex: 1,
                        ...imageStyles ?
                            imageStyles : {
                                width: "100%",
                                objectFit: "contain",
                            }
                    })}
                />

            </div>
            <div
                {...css({
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: backgroundColor,
                    height: "100%",
                    borderRadius: "12px",
                    overflow: "hidden",
                    transform: "translateZ(0)"
                })}
            >
                <span
                    {...css({
                        position: "absolute",
                        width: 0,
                        height: 0,
                        ...getTriangleStyles()
                    })}
                />
            </div>
        </div>
    )
}

export default ImageWrapper
